<template>
  <q-timeline-entry
    :title="message.content"
    :subtitle="dateFr"
    :side="side"
  >
    <lwf-card
      v-if="message.file || showLocation"
      class="q-ma-xs"
    >
      <lwf-map
        v-if="showLocation"
        key="map"
        :center="gLocation"
        :zoom="18"
        style="min-height: 300px"
      >
        <gmap-marker
          v-if="gLocation"
          v-bind="{ position: gLocation }"
        />
      </lwf-map>
      <lwf-photo
        v-else-if="message.file"
        key="photo"
        :picture="message.file"
      />
    </lwf-card>
    <div :class="'absolute-top-' + side">
      <q-btn
        :disable="!message.location"
        round
        flat
        :icon="showLocation && message.file ? 'fa fa-image' : 'fa fa-map-marker-alt'"
        @click="showLocation = !showLocation"
      />
      <q-btn
        v-if="!readonly"
        flat
        round
        icon="fa fa-ellipsis-v"
      >
        <q-menu>
          <q-item
            clickable
            @click="$emit('edit')"
          >
            <q-item-section>Modifier</q-item-section>
            <q-item-section side>
              <q-icon name="fa fa-edit" />
            </q-item-section>
          </q-item>
          <q-item
            clickable
            @click="$emit('delete')"
          >
            <q-item-section>Supprimer</q-item-section>
            <q-item-section side>
              <q-icon name="fa fa-trash" />
            </q-item-section>
          </q-item>
        </q-menu>
      </q-btn>
    </div>
  </q-timeline-entry>
</template>
<script>
import LwfCard from 'components/core/LwfCard'
import LwfPhoto from 'components/core/LwfPhoto'
import { dateTimeFormatFr } from '@/utils/data/date'
import { lwfToGmap } from '@/utils/io/geolocation'
import LwfMap from 'components/core/LwfMap'

export default {
  name: 'TimeLineEventsMessage',
  components: { LwfMap, LwfCard, LwfPhoto },
  props: {
    message: {
      type: Object,
      default: _.stubObject
    },
    side: {
      type: String,
      default: 'right'
    },
    readonly: Boolean
  },
  data () {
    return {
      showLocation: false
    }
  },
  computed: {
    gLocation () {
      return lwfToGmap(this.message.location)
    },
    dateFr () {
      return dateTimeFormatFr(this.message.createdAt)
    }
  }
}
</script>
